import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  FindAccountsReceivableInstallmentsFilterOptionsParams,
  FindBrandsFilterOptionsParams,
  FindCaseFilterOptionsParams,
  FindCaseStatusFilterOptionsParams,
  FindCatalogAccessClassificationsFilterOptionsParams,
  FindCatalogsFilterOptionsParams,
  FindCategoriesFilterOptionsParams,
  FindCitiesFilterOptionsParams,
  FindClassificationsFilterOptionsParams,
  FindCollectionsFilterOptionsParams,
  FindColorsFilterOptionsParams,
  FindConsultantsFilterOptionsParams,
  FindCustomerGroupsFilterOptionsParams,
  FindCustomersFilterOptionsParams,
  FindDeliveryWindowsFilterOptionsParams,
  FindInvoicesFilterOptionsParams,
  FindLocalsFilterOptionsParams,
  FindLocalsStatesFilterOptionsParams,
  FindOrderVouchersFilterOptionsParams,
  FindOrdersFilterOptionsParams,
  FindParentOrdersFilterOptionsParams,
  FindPriceTablesFilterOptionsParams,
  FindProductsFilterOptionsParams,
  FindPromotionCodesFilterOptionsParams,
  FindReferenceColorsFilterOptionsParams,
  FindSalesOpportunityFilterOptionsParams,
  FindSalesRepresentativesFilterOptionsParams,
  FindSalesTargetsFilterOptionsParams,
  FindSellersFilterOptionsParams,
  FindSizesFilterOptionsParams,
  FindSkuCodesFilterOptionsParams,
  FindStatesFilterOptionsParams,
  FindSuggestedCopiesFilterOptionsParams,
} from './filterOptions.types';
import { FindAdminTeamsFilterOptionsParams } from './filterOptions.types';

export const ADMIN_TEAMS_FILTER_OPTIONS_QUERY_KEY = 'admin-teams-filter-options';

export const getFindAdminTeamsFilterOptionsKey = (
  params: FindAdminTeamsFilterOptionsParams,
): UseDataQuery['queryKey'] => [ADMIN_TEAMS_FILTER_OPTIONS_QUERY_KEY, undefined, params ?? {}];

export const getFindCitiesFilterOptionsKey = (
  params: FindCitiesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CITIES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCustomersFilterOptionsKey = (
  params: FindCustomersFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CUSTOMERS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindPriceTablesFilterOptionsKey = (
  params: FindPriceTablesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.PRICE_TABLES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindStatesFilterOptionsKey = (
  params: FindStatesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.STATES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCustomerGroupsFilterOptionsKey = (
  params: FindCustomerGroupsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.CUSTOMER_GROUPS_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindSuggestedCopiesFilterOptionsKey = (
  params: FindSuggestedCopiesFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.SUGGESTED_COPIES_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindOrderVouchersFilterOptionsKey = (
  params: FindOrderVouchersFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.ORDER_VOUCHER_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindSalesRepresentativesFilterOptionsKey = (
  params: FindSalesRepresentativesFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.SALES_REPRESENTATIVES_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindSalesTargetsFilterOptionsKey = (
  params: FindSalesTargetsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SALES_TARGETS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindOrdersFilterOptionsKey = (
  params: FindOrdersFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.ORDERS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindSellersFilterOptionsKey = (
  params: FindSellersFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SELLERS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCollectionsFilterOptionsKey = (
  params: FindCollectionsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.COLLECTIONS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindProductsFilterOptionsKey = (
  params: FindProductsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.PRODUCTS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindStoreProductsFilterOptionsKey = (
  params: FindProductsFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/store-products', undefined, params ?? {}];

export const getFindKitsFilterOptionsKey = (
  params: FindProductsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.KITS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindLocalsStatesFilterOptionsKey = (
  params: FindLocalsStatesFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/locals/states', undefined, params ?? {}];

export const getFindColorsFilterOptionsKey = (
  params: FindColorsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.COLORS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindStoreColorsFilterOptionsKey = (
  params: FindColorsFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/store-colors', undefined, params ?? {}];

export const getFindReferenceColorsFilterOptionsKey = (
  params: FindReferenceColorsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.REFERENCE_COLORS_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindCategoriesFilterOptionsKey = (
  params: FindCategoriesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CATEGORIES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindDeliveryWindowsFilterOptionsKey = (
  params: FindDeliveryWindowsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.DELIVERY_WINDOWS_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindSizesFilterOptionsKey = (
  params: FindSizesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SIZES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindClassificationsFilterOptionsKey = (
  params: FindClassificationsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.CLASSIFICATIONS_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindClassificationsNoRbacFilterOptionsKey = (
  params: FindClassificationsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.CLASSIFICATIONS_NO_RBAC_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindSalesOpportunityFilterOptionsKey = (
  params: FindSalesOpportunityFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.SALES_OPPORTUNITY_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindCaseFilterOptionsKey = (
  params: FindCaseFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CASES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCaseStatusFilterOptionsKey = (
  params: FindCaseStatusFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CASE_STATUS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCaseAuthorsFilterOptionsKey = (
  params: FindCaseStatusFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CASE_AUTHORS_FILTER_OPTIONS, undefined, params ?? {}];
export const getFindCaseResponsiblesFilterOptionsKey = (
  params: FindCaseStatusFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.CASE_RESPONSIBLES_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindConsultantsFilterOptionsKey = (
  params: FindConsultantsFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CONSULTANTS_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindCatalogsFilterOptionsKey = (
  params: FindCatalogsFilterOptionsParams,
): UseDataQuery['queryKey'] => ['/catalogs', undefined, params ?? {}];

export const getFindInvoicesFilterOptionsKey = (
  params: FindInvoicesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.INVOICES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindAccountsReceivableFilterOptionsKey = (
  params: FindAccountsReceivableInstallmentsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.ACCOUNTS_RECEIVABLE_INSTALLMENTS_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindBrandsFilterOptionsKey = (
  params: FindBrandsFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/brands', undefined, params ?? {}];

export const getFindSkuCodesFilterOptionsKey = (
  params: FindSkuCodesFilterOptionsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SKU_CODES_FILTER_OPTIONS, undefined, params ?? {}];

export const getFindPromotionCodesFilterOptionsKey = (
  params: FindPromotionCodesFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.PROMOTION_CODES_FILTER_OPTIONS,
  undefined,
  params ?? {},
];

export const getFindCatalogAccessClassificationsFilterOptionsKey = (
  params: FindCatalogAccessClassificationsFilterOptionsParams,
): UseDataQuery['queryKey'] => [
  'filter-options/catalog-access-classifications',
  undefined,
  params ?? {},
];

export const getFindLocalsFilterOptionsKey = (
  params: FindLocalsFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/locals', undefined, params ?? {}];

export const getFindParentOrdersFilterOptionsKey = (
  params: FindParentOrdersFilterOptionsParams,
): UseDataQuery['queryKey'] => ['filter-options/parent-orders', undefined, params ?? {}];
